import React from 'react'

import {
  BlockEditor
} from '../../../components/block-editor'

import Navigation from '../../../components/navigation'

export default () => (
  <section>
    <header>
      <h1>Block Editor</h1>
    </header>
    <BlockEditor />
    <Navigation />
  </section>
)



/** WEBPACK FOOTER **
 ** ./pub/client/routes/IndexPage/BlockEditor/index.js
 **/